export default __webpack_public_path__ + "static/media/avatar_siti6.80f93362.mp3";